(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adv-cta-banner"] && !Shopify.designMode) return;
  try {
    
(function(){
  var h=document.getElementById('adv-hours');
  var m=document.getElementById('adv-mins');
  var s=document.getElementById('adv-secs');
  if(!h||!m||!s)return;
  var total=2*3600+14*60+33;
  var stored=sessionStorage.getItem('adv-timer');
  if(stored)total=parseInt(stored,10);
  function tick(){
    if(total<=0){total=0;}
    var hh=Math.floor(total/3600);
    var mm=Math.floor((total%3600)/60);
    var ss=total%60;
    h.textContent=String(hh).padStart(2,'0');
    m.textContent=String(mm).padStart(2,'0');
    s.textContent=String(ss).padStart(2,'0');
    sessionStorage.setItem('adv-timer',total);
    if(total>0)total--;
  }
  tick();
  setInterval(tick,1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["adv-sticky-cta"] && !Shopify.designMode) return;
  try {
    
(function(){
  var el=document.getElementById('sticky-timer');
  if(!el)return;
  var total=12*3600;
  var stored=sessionStorage.getItem('adv-sticky-timer');
  if(stored)total=parseInt(stored,10);
  function tick(){
    if(total<=0)total=0;
    var h=Math.floor(total/3600);
    var m=Math.floor((total%3600)/60);
    var s=total%60;
    el.textContent=String(h).padStart(2,'0')+':'+String(m).padStart(2,'0')+':'+String(s).padStart(2,'0');
    sessionStorage.setItem('adv-sticky-timer',total);
    if(total>0)total--;
  }
  tick();
  setInterval(tick,1000);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products"] && !Shopify.designMode) return;
  try {
    
(function() {
  var sections = document.querySelectorAll('.our-scents');

  for (var i = 0; i < sections.length; i++) {
    var section = sections[i];
    var track = section.querySelector('.our-scents__track');
    var prevBtn = section.querySelector('.our-scents__arrow--prev');
    var nextBtn = section.querySelector('.our-scents__arrow--next');

    if (!track || !prevBtn || !nextBtn) continue;

    (function(t, p, n) {
      var getScrollAmount = function() {
        var card = t.querySelector('.our-scents__card');
        if (!card) return 300;
        return (card.offsetWidth + 32) * 3;
      };

      p.addEventListener('click', function() {
        t.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
      });

      n.addEventListener('click', function() {
        t.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
      });
    })(track, prevBtn, nextBtn);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
